<template>
  <q-table
    v-if="rows"
    :rows="rows"
    :columns="columns"
    row-key="name"
    hide-bottom
    class="san-details-table"
    flat
    :rows-per-page-options="[0]"
  >
    <template #header="scope">
      <q-tr :props="scope">
        <q-th
          v-for="col in scope.cols"
          :key="col.name"
          :props="scope"
          :class="col.classes"
        >
          <div class="san-details-table--th-content">
            <!-- {{ console.log(col) }} -->
            {{ col.label }}
          </div>
        </q-th>
      </q-tr>
    </template>

    <template #body="scope">
      <q-tr
        :props="scope"
        class="cursor-pointer"
        @click="scope.row.onClick"
      >
        <q-td
          v-for="col in scope.cols"
          :key="col.name"
          :props="scope"
          auto-width
        >
          <component
            :is="() => renderCell(col, scope.row)"
            class="san-details-table--td-content"
            :class="col.contentClasses"
          />
        </q-td>
      </q-tr>
    </template>
  </q-table>
</template>

<script setup>
import { h } from 'vue' // eslint-disable-line

defineOptions({ name: 'SanListDetailsGrid' })

const props = defineProps({
  columns: { type: Array, default: null },
  rows: { type: Array, default: null }
})

const renderCell = (col, row) => { // eslint-disable-line
  const val = typeof col.field === 'function' ? col.field(row) : row[col.field] || row[col.name]
  const formatted = col.format !== void 0 ? col.format(val, row) : val
  return h('div', { class: 'ellipsis' }, Array.isArray(formatted) ? formatted.join(', ') : formatted)
}
</script>
